import React from "react"
import { connect } from "react-redux"

import Modal from "../common/components/Modal"
import * as interviewActions from "../interview/actions"

const msg500 = "We've encountered an error. Please try again."
const msg429 =
  "Thank you for using Buoy. At this time, usage is limited per user per day, so please come back tomorrow to continue symptom-checking."

const defaultButton = "Try again"
const redirectAtoZButton = "Go to Symptoms A-Z"

const ErrorModal = ({
  body,
  errorCode,
  buttonClick,
  navigateToSymptoms,
}) => {
  let msg = body
  let buttonText = defaultButton

  if (errorCode) {
    if (errorCode === 429) {
      msg = msg429
      buttonText = redirectAtoZButton
    } else if (errorCode === 500) {
      msg = msg500
    }
  }

  return msg ? (
    <Modal
      body={msg}
      buttonClick={buttonClick}
      showCancel={false}
      buttonText={buttonText}
    />
  ) : (
    <span />
  )
}

const mapStateToProps = state => ({
  body: state.modals.error,
  errorCode: state.modals.errorCode,
})

const mapDispatchToProps = dispatch => ({
  buttonClick: () => dispatch(interviewActions.startOver(true)),
  navigateToSymptoms: () => {
    window.location = "/symptoms-a-z/"
  },
})

const ErrorModalWrapper = connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorModal)

export { ErrorModalWrapper as default, ErrorModal }



// WEBPACK FOOTER //
// ./assets/modals/ErrorModal.js